import {BaseWidget} from "../BaseWidget";
import {BaseMuWidget} from "../BaseMuWidget";
import {MuNamedWidgets, MuWidget} from "mu-widget/lib/MuWidget";
import {ColumnInfo, UiTable} from "../components/UiTable";
import {MuRouter} from "mu-widget/lib/MuRouter";
import {Ticket} from "../TicketTypes";
import {BaseRouter} from "../BaseRouter";

export class PqmTicketList extends BaseMuWidget {
	beforeIndex() {
		this.muAppendContent(`
			<table mu="list:UiTable" class="table table-hover table-sticky-header">
				<tr mu-id="templates">
					<td mu=":UiTableCellTemplate@ticket"><a mu='link#value;level|append("em"):style.marginLeft' class="display-block"></a></td>
					<td mu=":UiTableCellTemplate@evidenceUid"><a mu='link#value' class="display-block"></a></td>
					<td mu=":UiTableCellTemplate@stateName">
						<div class="prod-data-ticket-tree-state" mu='#stateName;stateColor:style.backgroundColor'></div>
					</td>
					<td mu=":UiTableCellTemplate@pqmItem"><a mu="#value;pqmItem;pqmItemLink:href"></a></td>
				</tr>
			</table>
		`);
	}

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		list: UiTable,
	}>;

	afterIndex() {
		const self = this;
		const setupTicketLink = function(row: any) {
			const router = self.getRouter<BaseRouter>();
			// @ts-ignore
			router.paTicket(this.ui.link, row);
		}
		this.muNamedWidget.list.columns = [
			new ColumnInfo({ field:'summary', name: 'Požadavek', template: "ancestor:ticket",  widgetParams: {
				muAfterBindData: setupTicketLink
			}}),
			new ColumnInfo({ field:'evidenceUid', name: 'Evidenční číslo', template: "ancestor:evidenceUid", widgetParams: {
				muAfterBindData: setupTicketLink
			}}),
			new ColumnInfo({ field:'stateName', name: 'Stav', template: "ancestor:stateName" }),
			new ColumnInfo({ field:'pqmItemName', name: 'Proces', template: "ancestor:pqmItem" }),
		];
		// this.muNamedWidget.list.rowParams()
	}

	public loadItems(data: any) {
		this.muNamedWidget.list.data = data.tickets;
		this.muNamedWidget.list.render();
	}
}

export class PqmTicketLink extends BaseMuWidget
{
	public ticketId: number|null = null;

	public ticket: Ticket|null = null;

	// @ts-ignore
	container: HTMLAnchorElement;

	afterIndex() {
		this.update();
	}

	muBindData(srcData: any) {
		super.muBindData(srcData);
		if ("ticketId" in srcData) this.ticketId = srcData.ticketId;
		this.update();
	}

	update() {
		const router = this.getRouter();
		if (this.ticket) { // @ts-ignore
			router.paTicket(this.container, this.ticket);
		}
		else if (this.ticketId) router.prepareAnchor(this.container, 'ticket', { ticketId: this.ticketId.toString() });
	}
}